<template>
  <div>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        :style="`background-image:url('${gallery.headerImage}'); ${gallery.customStyles}`"
      ></parallax>
      <div class="container">
        <h1 class="title">{{gallery.name}}</h1>
      </div>
    </div>
    <div class="section">
      <div class="container gallery-container">
        <div v-masonry transition-duration="0s" item-selector=".item" gutter="30">
          <div
            v-masonry-tile
            class="item"
            v-for="(picture, index) in gallery.pictures"
            :key="picture.small"
            @click="openOverlay(picture, index)"
          >
            <card class="gallery-tile">
              <img slot="image" class="card-img-top" :src="picture.small" alt="Card image cap">
            </card>
          </div>
        </div>
      </div>
    </div>

    <lightbox
      v-if="gallery.pictures"
      :overlay-item="overlay.item"
      :visible="overlay.visible"
      :total-items="gallery.pictures.length"
      @closeSilentboxOverlay="hideOverlay"
      @requestNextSilentBoxItem="showNextItem"
      @requestPreviousSilentBoxItem="showPreviousItem"
    ></lightbox>
  </div>
</template>
<script>
  import { Card, Lightbox } from '@/components';
  import galleries from '@/galleries/galleries';
  import { metaTitles, metaDescriptions, metaImage } from '@/utils/meta';
  import trips from '@/trips/trips';

  export default {
    name: 'gallery',
    bodyClass: 'profile-page',
    metaInfo() {
      const title = this.gallery.name;
      return {
        title,
        meta: [
          ...metaTitles(title),
          ...metaDescriptions(`Gallery about ${title}`),
          ...metaImage(this.gallery.tileImage),
        ],
      };
    },
    components: {
      Card,
      Lightbox,
    },
    data() {
      return {
        gallery: {},
        overlay: {
          item: null,
          visible: false,
          currentItem: 0,
        },
      };
    },
    mounted() {
      const source = this.$route.meta.type === 'gallery' ? galleries : trips;
      this.gallery = source[this.$route.params.id];

      window.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          this.hideOverlay();
        }
        if (event.key === 'ArrowRight') {
          this.showNextItem();
        }
        if (event.key === 'ArrowLeft') {
          this.showPreviousItem();
        }
      });
    },
    beforeDestroy() {
      const htmlClasses = document.querySelector('body').classList;
      htmlClasses.remove('lightbox-open');
    },
    methods: {
      openOverlay(image, index) {
        this.overlay.visible = true;
        this.overlay.item = image;
        this.overlay.currentItem = index;

        const htmlClasses = document.querySelector('body').classList;
        htmlClasses.add('lightbox-open');
      },
      hideOverlay() {
        this.overlay.visible = false;

        const htmlClasses = document.querySelector('body').classList;
        htmlClasses.remove('lightbox-open');
      },
      showNextItem() {
        let newItemIndex = this.overlay.currentItem + 1;
        newItemIndex = newItemIndex <= this.gallery.pictures.length - 1
          ? newItemIndex : 0;

        this.overlay.item = this.gallery.pictures[newItemIndex];
        this.overlay.currentItem = newItemIndex;
      },
      showPreviousItem() {
        let newItemIndex = this.overlay.currentItem - 1;
        newItemIndex = newItemIndex > -1
          ? newItemIndex : this.gallery.pictures.length - 1;

        this.overlay.item = this.gallery.pictures[newItemIndex];
        this.overlay.currentItem = newItemIndex;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .gallery-container {
    padding: 0 50px;

    @media (max-width: 768px) {
      padding: 0;
    }
  }

  .item {
    width: calc(50% - 15px);

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .gallery-tile {
    cursor: pointer;
  }
</style>
